<template>
  <vs-popup class="add-new-regions"
            id="popup"
            :title="isCreateMode ? 'ADD REGION' : 'UPDATE REGION'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-regions-popup" @submit.prevent="handleSubmit(onClickCreateRegion)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="country_ids" name="country_ids" rules="required" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" multiple label="name" v-model="form.country_ids"
                          :reduce="option => option.id" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'" :closeOnSelect="false">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const RegionsRepository = RepositoryFactory.get('regions');
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')

  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        country_ids: [],
      },
      countryCodes: [],
      isCreateMode: true
    }
  }

  export default {
    name: 'AddNewRegionsPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.open = true;
          await this.loadCountryCode()
          if (!!id) {
            this.id = id
            this.isCreateMode = false
            await this.fetchRegionDetails()
          } else {
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
      async loadCountryCode() {
        this.$vs.loading()
        try {
          const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
          this.countryCodes =  data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async fetchRegionDetails() {
        await this.$vs.loading({
          container: '#create-regions-popup',
          scale: 0.45
        })
        try {
          const {data} = (await RegionsRepository.getRegion(this.id)).data
          this.form = data
          this.form.country_ids = data.country_codes.map((x) => x.id)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-regions-popup > .con-vs-loading')
      },
      async onClickCreateRegion() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-regions-popup',
          scale: 0.45
        })
        try {
          if (this.isCreateMode) {
            await RegionsRepository.createRegion(this.form);
            this.showSuccessMessage('Region created successfully!');
          } else {
            await RegionsRepository.updateRegion(this.id, this.form);
            this.showSuccessMessage('Region updated successfully!');
          }
          await vue.$parent.refreshData();
          this.open = false;
        } catch (e) {
          this.$vs.loading.close('#create-regions-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-regions-popup > .con-vs-loading')
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
    },
    components: {
      flatPickr,
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-regions >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
